import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAulaService } from '../../../../../../services/aula.service';
import { useNotificationService } from '../../../../../../services/notification.service';
import useBackClassroomPage from '../../../../hooks/use-back-classroom-page.hook';
import { AulaNaoOcorridaFormValues } from '../components/aula-nao-ocorrida-modal/aula-nao-ocorrida-modal.component';

export default function useRegistrarAulaNaoOcorrida() {
  const { id } = useParams();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const aulaService = useAulaService();
  const notificationService = useNotificationService();
  const { backClassroomPage } = useBackClassroomPage();
  const { t } = useTranslation('gestao_de_aulas');

  const submit = async (values: AulaNaoOcorridaFormValues) => {
    if (!id) return;

    setLoading(true);
    try {
      await aulaService.registrarAulaNaoOcorrida(Number(id), {
        motivo: values.motivo,
        descricao: values.descricao?.trim() || undefined
      });
      notificationService({
        type: 'success',
        message: t('gestao_de_aulas:lessonNotOccurredSuccess')
      });
      setOpen(false);
      backClassroomPage();
    } catch {
      notificationService({
        type: 'error',
        message: t('gestao_de_aulas:lessonNotOccurredError')
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    open,
    loading,
    show: () => setOpen(true),
    close: () => setOpen(false),
    submit
  };
}
